import { Attachment, Translations, UUID } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { AccessoryCategory } from './AccessoryCategoryApi';
import { AccessoryNameOverride } from './AccessoryNameOverrideApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AccessoryRelationAction {
	SHOW = 'show',
	HIDE = 'hide',
}

export interface AccessoryRelation {
	action: AccessoryRelationAction;
	accessories: UUID[];
}

export interface Accessory extends BaseEntity {
	name: string;
	description: string;
	listOrder: number;
	slug: string;
	code: string;
	collisionLayers: number[];
	category?: AccessoryCategory;
	relations: AccessoryRelation[];
	nameOverrides: AccessoryNameOverride[];
	image: Attachment | null;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AccessoryApi extends EntityApi<Accessory> {
	constructor() {
		super(QueryKey.accessories);
	}
}

export default new AccessoryApi();
